export default __webpack_public_path__ + "bbce9ad46af1a58e5b9838858d444e1d.png";